import { Controller } from "@hotwired/stimulus"

import SearchMapController from "./search_map_controller"
import PriceRangeController from "./price_range_controller"

import * as Bloomreach from "@/helpers/bloomreach"
import { saveNavigationTypeToStorage, selectContentEvent } from "@/helpers/ga4_helper"
import { urlWithBounds } from "@/helpers/search_map"

export default class PriceFilterController extends Controller<HTMLElement> {
  static outlets = ["price-range", "search-map"]
  declare readonly priceRangeOutlet: PriceRangeController
  declare readonly searchMapOutlet: SearchMapController

  static targets = ["priceLink"]
  declare readonly priceLinkTarget: HTMLAnchorElement

  applyFilter(): void {
    const href = this.isWholeRangeCovered ? this.element.dataset.urlForRemove! : this.urlForApply
    const url = urlWithBounds(href, this.searchMapOutlet.mapBounds)

    if (url.pathname === window.location.pathname) {
      return
    }

    this.priceLinkTarget.setAttribute("href", url.toString())
    this.priceLinkTarget.click()

    selectContentEvent("Search Filters", this.priceRangeOutlet.selectedRangeAsString(), {
      itemListName: "Price Filter"
    })
    saveNavigationTypeToStorage("filtered")
    Bloomreach.saveSearchTermToStorage("")
  }

  private get isWholeRangeCovered(): boolean {
    const lowerValue = +this.priceRangeOutlet.lowerInputTarget.value
    const upperValue = +this.priceRangeOutlet.upperInputTarget.value

    return lowerValue === 0 && upperValue === this.priceRangeOutlet.maxValue
  }

  private get urlForApply(): string {
    const { urlPrefix, urlSuffix } = this.element.dataset

    return `${urlPrefix}${this.priceRangeOutlet.selectedRangeAsString()}${urlSuffix}`
  }
}
